module.exports = __webpack_public_path__ + "static/media/bell.709c40c5.svg";